import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Popup, Input, toast, setOptions, Button, Select, Textarea} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderConversationNew.css';
import Empty from "../utils/Empty";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderConversationNew({locale, dialog, Dialog, setMessages, setText, Navigation, width, setWorkspace, setTeamtalk, setStack, configuration, archive, setArchive, Conversation, setTokensUsed, setFolded, label, setLabel}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [name, setName] = useState(null);
    const [personality, setPersonality] = useState(() => {
        const item = configuration.mobi.personalities.general.find(personalityItem => personalityItem.default);
        return item.value;
    });
    const [group, setGroup] = useState('general');
    const [voice, setVoice] = useState(() => {
        const item = configuration.mobi.voice.find(voiceItem => voiceItem.default);
        return item.value;
    });
    const [ai, setAi] = useState(() => {
        const item = configuration.mobi.model.find(modelItem => modelItem.default);
        return item.value;
    });
    const [prompt, setPrompt] = useState(null);

    const DialogClose = useCallback(() => {
        setArchive({});
        Dialog({view: 'close'});
    }, [Dialog]);

    const Header = () => {
        if (dialog.tab === 'archive') {
            return locale.dashboardHeaderConversationNew.i;
        } else if (dialog.tab === 'conversation') {
            return locale.dashboardHeaderConversationNew.e;
        } else if (dialog.tab === 'teamtalk') {
            return locale.dashboardHeaderConversationNew.j;
        }
    }

    const SelectGroup = data => {
        setGroup(data);
        const personalityItem = configuration.mobi.personalities[data].find(item => item.default);

        if (personalityItem) {
            setPersonality(personalityItem.value);
        } else {
            setPersonality(configuration.mobi.personalities[data].sort((a, b) => a.text.localeCompare(b.text, locale))[0].value);
        }
    }

    const ButtonSave = () => {
        if (!name) {
            toast({message: locale.dashboardHeaderConversationNew.c, color: 'danger', display: 'bottom', duration: 3000});
        } else if (!personality) {
            toast({message: locale.dashboardHeaderConversationNew.l, color: 'danger', display: 'bottom', duration: 3000});
        } else if (name && personality) {

            const message = {
                type: 'wss',
                path: 'tab',
                action: 'put',
                data: {
                    name: name,
                    personality: personality,
                    voice: voice,
                    ai: ai,
                    prompt: prompt,
                    label: label,
                    archive: (!Empty(archive) && archive.timestamp) ? archive : null,
                    teamtalk: dialog.tab === 'teamtalk' ? true : null
                }
            };
            wsCall(message);
        }
    }

    const PutTab = useCallback(data => {
        if (data.label) {
            setLabel(data.label);
        }
        if (data.tab) {
            setMessages([]);
            setTokensUsed(0);
            setWorkspace([]);
            setStack([]);
            setText('<p></p>');
            setFolded(false);
            window.localStorage.text = '<p></p>';

            Navigation({tab: data.tab});
        }
        if (data.archive) {
            Conversation();
        }
        if (data.teamtalk) {
            setMessages([]);
            setWorkspace([]);
            setStack([]);
            setText('<p></p>');
            window.localStorage.text = '<p></p>';
            setTeamtalk(data.teamtalk);

            Navigation({tab: 'teamtalk'});
        } else {
            setTeamtalk({});
        }
        DialogClose();
    }, [DialogClose, Navigation, Conversation]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'tab') {
            PutTab(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutTab, setWsResponse]);

    return (
        <Popup className="cs-dashboard-header-conversation-new-popup" width={600} display="center" scrollLock={true} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderConversationNew'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-conversation-new-header-col">
                <div className="mbsc-row cs-dashboard-header-conversation-new-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-conversation-new-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-conversation-new-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-conversation-new-header-col"} >
                        <Button className="cs-dashboard-header-conversation-new-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {Header()}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-conversation-new-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-conversation-new-close-button" onClick={() => DialogClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-header-conversation-new-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <Input inputStyle="underline" label={locale.dashboardHeaderConversationNew.b} labelStyle="floating" type="text" name="account" value={name} onChange={ev => {setName(ev.target.value) }} />
            <div className="mbsc-form-group">
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardHeaderConversationNew.k}
                    labelStyle="floating"
                    touchUi={false}
                    rows={configuration.mobi.personalitiesGroups.length}
                    display="anchored"
                    data={configuration.mobi.personalitiesGroups}
                    value={group}
                    onChange={args => SelectGroup(args.value)}
                />
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardHeaderConversationNew.a}
                    labelStyle="floating"
                    touchUi={false}
                    rows={configuration.mobi.personalities[group].length}
                    display="anchored"
                    data={configuration.mobi.personalities[group].sort((a, b) => a.text.localeCompare(b.text, locale))}
                    value={personality}
                    onChange={args => setPersonality(args.value)}
                />
            </div>
            <Select
                animation="slide-down"
                inputStyle="underline"
                label={locale.dashboardHeaderConversationNew.f}
                labelStyle="floating"
                touchUi={false}
                rows={configuration.mobi.voice.length}
                display="anchored"
                data={configuration.mobi.voice}
                value={voice}
                onChange={args => setVoice(args.value)}
            />
            {configuration.ui.dashboard.model &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    dropdown={false}
                    label={locale.dashboardHeaderConversationNew.g}
                    labelStyle="floating"
                    rows={configuration.mobi.model.length}
                    display="anchored"
                    touchUi={false}
                    data={configuration.mobi.model}
                    value={ai}
                    onChange={args => setAi(args.value)}
                />
            }
            <div className="cs-dashboard-header-conversation-new-helper">
                <p>{locale.dashboardHeaderConversationNew.h}</p>
            </div>
            <div className="cs-dashboard-header-conversation-new-textarea">
                <Textarea
                    inputStyle="underline"
                    labelStyle="floating"
                    rows={3}
                    value={prompt}
                    onChange={(ev) => setPrompt(ev.target.value)}
                />
            </div>
            <div className="mbsc-button-group-justified cs-dashboard-header-conversation-new-nav-buttons">
                <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-conversation-new-nav-button" onClick={() => ButtonSave()} >
                    {locale.dashboardHeaderConversationNew.d}
                </Button>
            </div>
        </Popup>
    );
}

export default DashboardHeaderConversationNew;
